import { useEffect, useState } from "react";

import { getStatesByCountry } from "../api";
import { isNotEmptyString } from "../utils";

export default function useStatesByCountry(countryCode, onError) {
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState(null);

  useEffect(() => {
    async function fetchStates() {
      try {
        const result = await getStatesByCountry(countryCode);
        setStates(result);
      } catch (err) {
        onError(err);
      }
      setLoading(false);
    }

    if (isNotEmptyString(countryCode)) {
      setLoading(true);
      fetchStates();
    }
  }, [countryCode, onError]);

  return [states, loading];
}
